import Component from './spinner';
export default Component;
